import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "../../../../../utils/api";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import { useState } from "react";
import { T_Evento } from "../../../../../components/selects/celula";
import useLoading from "../../../../../hooks/useLoading";
import { useServicesEventosCheckin } from "../../context/getServicesEventos";


const ServicesEdit = () => {

  const { id } = useParams()

  const { startLoading, stopLoading, isLoading } = useLoading();

  const { reset } = useServicesEventosCheckin()

  const { setMensagemSuccess, setMensagemError } = useErrorSuccess();

  const [evento, setEvento] = useState<T_Evento>();

  const [dateForm, setDateForm] = useState<{inicioForm: string | Date, fimForm: string | Date}>();

  const alterEvento = (field: keyof (T_Evento & { inicioForm: string | Date, fimForm: string | Date }), value: any) => {
    if(field == 'inicioForm') {
      setDateForm((date) => ({...date, inicioForm: value}))
      return;
    }
    if(field == 'fimForm') {
      setDateForm((date) => ({...date, fimForm: value}))
      return;
    }
    setEvento((event) => ({...event, [field]: value}))
  }

  const get = async () => {
    startLoading();
    try {
      const req = await api.get('evento/geral/'+id);
      const res = req.data;

      setEvento(res);

    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    }finally {
      stopLoading();
    }
  }

  const handleUpdate = async() => {
    try {
      const req = await api.put('evento/geral/'+id, evento);
      const res = await req.data;
      setMensagemSuccess('Alterado!');
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2));
    }finally {
      reset();
    }
  }

  const { } = useQuery({
    queryKey: ['get-evento', id],
    queryFn: get
  })


  return {
    get,
    evento: {...evento, ...dateForm},
    alterEvento,
    handleUpdate
  };
}

export default ServicesEdit;
